import {reportYear,entityOaid} from '../../util/util'
const report_year_list=reportYear.esg_report_years
export default {
  delimiters: ['{', '}'],
  props: {

  },
  data: () => {
    return {
      oaid: null,
      industry: "",
      officialName: "",
      report_date: [],
    }
  },
  methods: {
    callIndicationTable(){
      let id = this.$route.params.oaid
      let self = this
      reportYear.esg_report_month().then(result => {
        self.report_date = result.report_annual_list
      })
      entityOaid.oaid(id).then(result => {
        self.oaid =result
      })
    }
  },
  mounted () {
    this.callIndicationTable()
  }
}



// WEBPACK FOOTER //
// ./src/esg/js/esg_bondissuer_indicator_annual.js